import { adminHttpClient } from '../../../commons/adminHttpClient'

import { ReimbursementMethod } from 'domain/expenses/reimbursementMethod'

export interface ReimbursementsDueValues {
  planPeriodId: string
  scheduledDate: Date
  reimbursementMethod: ReimbursementMethod
  otherReimbursementMethod: string
  userReimbursements: UserReimbursementRequest[]
  reimbursementsThrough?: string
}

export type UserReimbursementRequest = {
  companyUserId: string
  overrideReimbursementDue?: number
}

export interface ExpenseInfo {
  expenseId: string
  amount: number
  taxable: number
  nonTaxed: number
}

const submitReimbursementsDue = (reimbursementsDue: ReimbursementsDueValues): Promise<any> => {
  return adminHttpClient.post('/AdminDashboard/ReimbursementsDue/ReimburseEmployee', reimbursementsDue)
}

export default submitReimbursementsDue
